module.exports = __webpack_public_path__ + "static/media/add-application.9d561bc8.svg";